import { Grid, Tooltip } from "@mui/material";
import React from "react";
import { TitleHolder } from "../../common/sharedComponents/styles/card.style";
import { AddButton } from "../bankDetails/components/bankAccountsContent";
import { StepperContentHolder } from "../vendorRegistration/vendorRegistration";
import InspectionModuleTableContent from "./components/inspectionModuleTableContent";

function InspectionModuleTable() {
  return (
    <div>
      <TitleHolder style={{ paddingBottom: "0" }}>
        <Grid container spacing={1}>
          <Grid sx={{ whiteSpace: "nowrap" }} item xs={6}>
            Inspections
          </Grid>
          <Grid item xs={6}>
            <div style={{ textAlign: "right" }}>
              <Tooltip title="Initiate an Inspection">
                <AddButton replace to="/app/inspections"></AddButton>
              </Tooltip>
            </div>
          </Grid>
        </Grid>
      </TitleHolder>
      <br />
      <StepperContentHolder>
        <InspectionModuleTableContent />
      </StepperContentHolder>
    </div>
  );
}

export default InspectionModuleTable;